/* DANYCARE: Volltextsuche an die Vorschlagsliste angleichen.
   Die Ergebnisseite matcht nur ganze Wörter – „juve“ fände Juvéderm nicht,
   obwohl die Vorschlagsliste (Präfix-Suche) es zeigt. Dawns options[prefix]=last
   greift dort nicht (Akzent-Normalisierung fehlt beim Präfix-Match), eine
   Wildcard am letzten Begriff (juve → juve*) dagegen schon.
   Läuft als document-Listener in der Bubble-Phase, damit Dawns eigene
   Submit-Handler (z. B. Tastatur-Auswahl in der Vorschlagsliste, die den
   Submit abbricht) zuerst entscheiden. */
document.addEventListener('submit', (event) => {
  if (event.defaultPrevented) return;
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  if (!(form.getAttribute('action') || '').includes('/search')) return;
  const input = form.querySelector('input[name="q"]');
  if (!input) return;
  const query = input.value.trim();
  if (!query || query.endsWith('*') || query.includes('"')) return;
  input.value = query + '*';
});
